/* import __COLOCATED_TEMPLATE__ from './request-text.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './request-text.module.scss';

@classic
@classNames('d-flex', 'flex-column', 'justify-content-center', styles.component)
export default class RequestRequestText extends Component {}
